import { useState, useMemo } from "react";
import { MdOutlineArrowBackIos, MdOutlineArrowForwardIos, MdOutlineClose } from "react-icons/md";
import { HiChevronLeft, HiChevronDown, HiSearch, HiChevronRight, HiOutlineMail } from 'react-icons/hi';
import moment from 'moment';

// ── Data ──────────────────────────────────────────────────────────────────────
const EMPLOYEES = Array.from({ length: 150 }, (_, i) => {
  const names = [
    "Aarav Sharma", "Priya Patel", "Riya Singh", "Amit Kumar",
    "Neha Gupta", "Vikram Mehta", "Ananya Rao", "Rohit Joshi",
    "Sunita Verma", "Deepak Nair",
  ];
  const name = names[i % names.length];
  const slug = name.toLowerCase().replace(/\s+/, ".").replace(/[^a-z.]/g, "");
  return { id: i + 1, name, email: `${slug}${i > 0 ? i : ""}@companydemo.in` };
});

const formData = {
  caseStudies: ['Case Study 1', 'Case Study 2', 'Case Study 3'],
  rolePlays: ['Role Play 1', 'Role Play 2', 'Role Play 3'],
  surveys: ['TalentPlus Strengths Assessment', 'Culture Fit Survey', 'Technical Review']
};

const STEPS = ["Employee", "Activities", "Emails"];
const PER_PAGE_OPTIONS = [5, 10, 20];

// ── StepIndicator ─────────────────────────────────────────────────────────────
function StepIndicator({ step }) {
  return (
    <div className="flex items-center pb-5">
      {STEPS.map((label, idx) => {
        const stepNum = idx + 1;
        const isActive = stepNum === step;
        const isDone = stepNum < step;
        return (
          <div key={label} className="flex items-center flex-1 last:flex-none">
            <div className="flex items-center md:gap-2 gap-1 shrink-0">
              <div
                className={`md:w-7 md:h-7 w-5 h-5 rounded-full flex items-center justify-center md:text-base text-sm font-semibold transition-colors
                  ${isActive || isDone
                    ? "bg-indigo-600 text-white"
                    : "bg-indigo-600 text-white border border-gray-300"
                  }`}
              >
                {stepNum}
              </div>
              <span
                className={`md:text-sm text-xs font-medium whitespace-nowrap
                  ${isActive ? "text-indigo-600" : "textblack"}`}
              >
                {label}
              </span>
            </div>
            {idx < STEPS.length - 1 && (
              <div
                className={`flex-1 h-1 mx-3 rounded-full
                  ${isDone ? "bg-indigo-600" : "bg-gray-200"}`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}

// ── SearchInput ───────────────────────────────────────────────────────────────
function SearchInput({ value, onChange }) {
  return (
    <div className="relative flex-1 min-w-[120px]">
      <svg
        className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 textblack"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        viewBox="0 0 20 20"
      >
        <circle cx="9" cy="9" r="6" />
        <path d="m15 15 3 3" strokeLinecap="round" />
      </svg>
      <input
        type="text"
        placeholder="Search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-9 pr-3 py-1.5 w-72 text-sm border border-gray-300 rounded-md focus:outline-none bg-white textblack placeholder-gray-400 transition-shadow"
      />
    </div>
  );
}

// ── PaginationButton ──────────────────────────────────────────────────────────
function PaginationButton({ onClick, disabled, children }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="w-7 h-7 flex items-center justify-center border border-gray-300
        rounded-md bg-indigo-100 hover:bg-indigo-100 hover:border-indigo-600
        disabled:opacity-40 disabled:cursor-not-allowed text-indigo-600
        transition-colors text-base leading-none"
    >
      {children}
    </button>
  );
}

// ── TableHeader ───────────────────────────────────────────────────────────────
function TableHeader({ columns, allChecked, onToggleAll }) {
  return (
    <>
      {/* <table className="w-full text-sm">
        <thead className="bg-indigo-100 border-b border-gray-300">
          <tr>
            <th className="w-12 px-4 py-3">

            </th>

            {columns.map((col) => (
              <th className="text-left px-3 py-3 font-semibold textblack">
                {col.label}
              </th>))}
          </tr>
        </thead>
      </table> */}
      <thead className="bg-gray-100 border-b border-gray-300 sticky top-0 z-10">
        <tr>
          <th className="px-4 py-3 text-left"></th>

          {columns.map((col) => (
            <th
              key={col.value}
              className="px-3 py-3 text-left font-semibold whitespace-nowrap"
            >
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
    </>
  );
}

// ── TableRow ──────────────────────────────────────────────────────────────────
function TableRow({ sno, columns, employee, handleEmpSelect, isChecked, onToggle }) {
  return (
    <>
      <tr
        onClick={onToggle}
        className={`border-t border-gray-300 cursor-pointer
        ${isChecked ? "bg-indigo-100" : "hover:bg-gray-50"}`}
      >
        <td className="px-4 py-3">
          <input type="checkbox" checked={isChecked} />
        </td>

        {columns.map((col) => (
          <td
            key={col.value}
            className="px-3 py-3 whitespace-nowrap"
          >
            {col.value === "sno" ? sno : employee[col.value]}
          </td>
        ))}
      </tr>


      {/* <tr
      onClick={onToggle}
      className={`border-t border-gray-300 cursor-pointer transition-colors
        ${isChecked ? "bg-indigo-100 hover:bg-indigo-100" : "hover:bg-gray-50"}`}
    >
      <td className="w-12 px-4 py-3">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={() => handleEmpSelect()}
          onClick={(e) => e.stopPropagation()}
          className="w-4 h-4 text-indigo-600 cursor-pointer rounded"
        />
      </td>

      {columns.map((col) => (
        <td className={`text-left px-3 py-3 whitespace-nowrap ${isChecked ? "font-semibold text-indigo-600" : "textblack"}`}>
          {employee[col.value]}
        </td>))}
    </tr> */}


    </>
  );
}

// ── AssignActivities (Main) ───────────────────────────────────────────────────
export default function AssignActivities(props) {

  let { onClose, step, assignFormData = {}, empList = [], getInsightSurveyListData = [], getCaseStudyListData = [], getRolePlayListData = [], getInsightMailLibraryListData = [], handleChange, handleMailSelect, handleEmpSelect, prevStep, nextStep, handleFinalAssign } = props;

  const [currentStep] = useState(1);
  const [search, setSearch] = useState("");
  const [perPage, setPerPage] = useState(20);
  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState(new Set());

  // Filtered list
  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return q
      ? EMPLOYEES.filter(
        (e) =>
          e.name.toLowerCase().includes(q) ||
          e.email.toLowerCase().includes(q)
      )
      : EMPLOYEES;
  }, [search]);

  // Paginated slice
  const totalPages = Math.ceil(filtered.length / perPage);
  const startIdx = (page - 1) * perPage;
  const pageData = filtered.slice(startIdx, startIdx + perPage);

  // All rows on current page checked?
  const allPageChecked =
    pageData.length > 0 && pageData.every((e) => selected.has(e.id));

  // Selected employees for JSON output
  const selectedEmployees = EMPLOYEES.filter((e) => selected.has(e.id)).map(
    ({ id, name, email }) => ({ id, name, email })
  );

  // ── Handlers ────────────────────────────────────────────────────────────────
  const handleSearch = (val) => {
    setSearch(val);
    setPage(1);
  };

  const handlePerPage = (val) => {
    setPerPage(Number(val));
    setPage(1);
  };

  const toggleRow = (id) => {
    setSelected((prev) => (prev === id ? null : id));
  };

  const toggleAll = () => {
    const allIds = pageData.map((e) => e.id);
    const allChecked = allIds.every((id) => selected.has(id));
    setSelected((prev) => {
      const next = new Set(prev);
      allIds.forEach((id) => (allChecked ? next.delete(id) : next.add(id)));
      return next;
    });
  };

  // const handleContinue = () => {
  //   if (!selected.size) {
  //     alert("Please select at least one employee.");
  //     return;
  //   }
  //   alert(`Proceeding with ${selected.size} employee(s).`);
  // };


  const list = empList.map((ele, i) => ({
    id: ele.id,
    clicked: assignFormData.employeeId === ele.id,
    emp_id: ele.emp_id,
    name: ele.name,
    email: ele.email
  }))

  const columns = [
    { value: "sno", label: "S No" },
    { value: "emp_id", label: "Emp ID" },
    { value: "name", label: "Name" },
    { value: "email", label: "Email" },
  ]



  // ── Render ──────────────────────────────────────────────────────────────────
  return (
    <div className="min-h-screen z-50 p-4 fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="md:px-8 px-4 py-6 bg-white rounded-2xl shadow-xl w-full max-w-5xl border border-gray-300 overflow-hidden">

        <div className="flex items-center justify-between pb-5">
          <div>
            <h2 className="text-xl font-semibold textblack">Assign Activities</h2>
            <p className="text-sm textblack mt-1">
              Assign activities to employees in 3 simple steps.
            </p>
          </div>
          <div onClick={onClose} className="p-2 rounded-full cursor-pointer bg-slate-100 hover:bg-slate-200 ">
            <MdOutlineClose size={22} className="textblack" />
          </div>
        </div>

        {/* Step Indicator */}
        <StepIndicator step={step} />

        {/* STEP 1 - EMPLOYEE SELECT */}
        {step === 1 && (
          <>
            {/* Table */}
            <div className="w-full">
              <div className="border border-gray-300 rounded-md overflow-hidden p-6">
                {/* Table Controls */}
                <div className="mb-5">
                  <div className="flex items-center gap-3 flex-wrap">
                    {/* Entries selector */}
                    <div className="flex items-center gap-2">
                      <span className="text-sm textblack">Show</span>
                      <select
                        value={perPage}
                        onChange={(e) => handlePerPage(e.target.value)}
                        className="border border-gray-300 rounded-md px-2 py-1.5 text-sm textblack focus:outline-none bg-white cursor-pointer"
                      >
                        {PER_PAGE_OPTIONS.map((n) => (
                          <option key={n} value={n}>{n}</option>
                        ))}
                      </select>
                      <span className="text-sm textblack">Entries</span>
                    </div>

                    <div>
                      <SearchInput value={search} onChange={handleSearch} />
                    </div>

                    <div className="flex items-center gap-2 ml-auto">
                      <span className="text-sm textblack whitespace-nowrap">
                        {startIdx + 1}–{Math.min(startIdx + perPage, filtered.length)} of{" "}
                        {filtered.length}
                      </span>
                      <PaginationButton
                        onClick={() => setPage((p) => p - 1)}
                        disabled={page === 1}
                      >
                        <MdOutlineArrowBackIos size={20} />
                      </PaginationButton>
                      <PaginationButton
                        onClick={() => setPage((p) => p + 1)}
                        disabled={page >= totalPages}
                      >
                        <MdOutlineArrowForwardIos size={20} />
                      </PaginationButton>
                    </div>
                  </div>
                </div>

                <div className="w-full overflow-x-auto">
                  <div className="min-w-[600px] max-h-72 overflow-y-auto">
                    <table className="w-full text-sm">
                      <TableHeader columns={columns} allChecked={allPageChecked} onToggleAll={toggleAll} />
                      <tbody>
                        {list.map((emp, index) => (
                          <TableRow
                            sno={index + 1}
                            key={emp.id}
                            columns={columns}
                            employee={emp}
                            isChecked={assignFormData.employeeId === emp.id}
                            onToggle={() => handleEmpSelect(emp.id)}
                          />
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* <div className="w-full overflow-x-auto">
                  <div className="min-w-[600px]">
                    <TableHeader columns={columns} allChecked={allPageChecked} onToggleAll={toggleAll} />
                    <div className="max-h-72 w-full overflow-y-auto">
                      {list.length === 0 ? (
                        <div className="text-center py-10 text-sm textblack">
                          No employees found.
                        </div>
                      ) : (
                        <table className="w-full text-sm">
                          <tbody>
                            {list.map((emp) => (
                              <TableRow
                                key={emp.id}
                                columns={columns}
                                employee={emp}
                                handleEmpSelect={() => handleEmpSelect(emp.id)}
                                isChecked={assignFormData.employeeId === emp.id}
                                onToggle={() => toggleRow(emp.id)}
                              />
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </div> */}

              </div>
            </div>
          </>
        )}
        {step === 2 && (
          <>
            {/* Form Body */}
            <div className="space-y-4">

              {/* Introduction Meeting Link */}
              <div className="space-y-1">
                <label className="block textblack text-sm font-medium">Introduction Meeting Link</label>
                <input
                  name="introMeetingLink"
                  placeholder="Introduction Meeting Link"
                  value={assignFormData.introMeetingLink || ""}
                  onChange={handleChange}
                  className="w-full border border-purple-300 border-2 rounded-lg px-3 py-2 outline-none transition-all"
                />
              </div>


              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                {/* Case Study Link */}
                <div className="space-y-1">
                  <label className="block textblack text-sm font-medium">Enter Behavioral Event Interview (BEI) Meeting Link</label>
                  <input
                    name="caseStudyMeetingLink"
                    placeholder="Case Study Meeting Link"
                    value={assignFormData.caseStudyMeetingLink || ""}
                    onChange={handleChange}
                    className="w-full border border-purple-300 border-2 rounded-lg px-3 py-2 outline-none"
                  />
                </div>

                {/* Role Play Link */}
                <div className="space-y-1">
                  <label className="block textblack text-sm font-medium">Enter Role Play Meeting Link</label>
                  <input
                    name="rolePlayMeetingLink"
                    placeholder="Role Play Meeting Link"
                    value={assignFormData.rolePlayMeetingLink || ""}
                    onChange={handleChange}
                    className="w-full border border-purple-300 border-2 rounded-lg px-3 py-2 outline-none"
                  />
                </div>
              </div>


              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Case Study Selection */}
                <div className="space-y-1">
                  <label className="block textblack text-sm font-medium">Select Case Study</label>
                  <div className="relative">
                    <select
                      name="caseStudyId"
                      value={assignFormData.caseStudyId || ""}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-white appearance-none outline-none">
                      <option key={""} value={""}>
                        {"Select Case Study"}
                      </option>
                      {getCaseStudyListData.map((i) => (
                        <option key={i.id} value={i.id}>
                          {i.name}
                        </option>
                      ))}
                    </select>
                    <HiChevronDown className="absolute right-3 top-3 textblack text-xl pointer-events-none" />
                  </div>
                </div>


                {/* Role Play Selection */}
                <div className="space-y-1">
                  <label className="block textblack text-sm font-medium">Select Role Play</label>
                  <div className="relative">
                    <select
                      name="rolePlayId"
                      value={assignFormData.rolePlayId || ""}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-white appearance-none outline-none">
                      <option key={""} value={""}>
                        {"Select Role Play"}
                      </option>
                      {getRolePlayListData.map((i) => (
                        <option key={i.id} value={i.id}>
                          {i.name}
                        </option>
                      ))}
                    </select>
                    <HiChevronDown className="absolute right-3 top-3 textblack text-xl pointer-events-none" />
                  </div>
                </div>


              </div>



              {/* Survey Selection */}
              <div className="pb-10">
                <div className="space-y-1 ">
                  <label className="block textblack text-sm font-medium">Select Survey</label>
                  <div className="relative">
                    <select
                      name="surveyId"
                      value={assignFormData.surveyId || ""}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-white appearance-none outline-none">
                      <option key={""} value={""}>
                        {"Select Survey"}
                      </option>
                      {getInsightSurveyListData.map((i) => (
                        <option key={i.id} value={i.id}>
                          {i.name}
                        </option>
                      ))}
                    </select>
                    <HiChevronDown className="absolute right-3 top-3 textblack text-xl pointer-events-none" />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}


        {step === 3 && (
          <>
            {/* Table Controls */}

            <div className="w-full">
              <div className="w-full border border-gray-300 rounded-md overflow-hidden p-4 sm:p-6">

                {/* Controls (unchanged) */}
                <div className="w-full flex flex-col sm:flex-row sm:items-center gap-3 mb-5">

                  <div className="flex flex-wrap items-center gap-3">
                    <div className="flex items-center gap-2">
                      <span className="text-sm textblack">Show</span>
                      <select
                        value={perPage}
                        onChange={(e) => handlePerPage(e.target.value)}
                        className="border border-gray-300 rounded-md px-2 py-1.5 text-sm textblack focus:outline-none bg-white cursor-pointer">
                        {PER_PAGE_OPTIONS.map((n) => (
                          <option key={n} value={n}>{n}</option>
                        ))}
                      </select>
                      <span className="text-sm textblack">Entries</span>
                    </div>
                    <SearchInput value={search} onChange={handleSearch} />
                  </div>

                  <div className="flex items-center gap-2 sm:ml-auto">
                    <span className="text-sm textblack whitespace-nowrap">
                      {startIdx + 1}–{Math.min(startIdx + perPage, filtered.length)} of{" "}
                      {filtered.length}
                    </span>
                    <PaginationButton onClick={() => setPage((p) => p - 1)} disabled={page === 1}>
                      <MdOutlineArrowBackIos size={20} />
                    </PaginationButton>
                    <PaginationButton onClick={() => setPage((p) => p + 1)} disabled={page >= totalPages}>
                      <MdOutlineArrowForwardIos size={20} />
                    </PaginationButton>
                  </div>
                </div>

                <div className="w-full overflow-x-auto scollbar">
                  <div className="min-w-[600px]">

                    <div className="overflow-y-auto max-h-96 scollbar">
                      {getInsightMailLibraryListData.map((mail) => (
                        <div key={mail.id} className="w-full flex items-start gap-3 p-3 sm:p-4 border-b border-gray-300 last:border-none hover:bg-gray-100">
                          <div className="pt-1 flex-shrink-0">
                            <input type="checkbox"
                              key={mail.id}
                              checked={assignFormData.mailIdList?.includes(mail.id)}
                              onChange={() => handleMailSelect(mail.id)}
                              className="w-4 h-4 rounded border-gray-300 text-indigo-600 cursor-pointer" />
                          </div>
                          <div className="flex-shrink-0 w-9 h-9 sm:w-11 sm:h-11 bg-indigo-100 rounded-full flex items-center justify-center">
                            <HiOutlineMail className="text-indigo-600 text-lg sm:text-xl" />
                          </div>
                          <div className="flex-1">
                            <h3 className="text-sm sm:text-base font-semibold">{mail.subject}</h3>
                            <div className="text-sm space-y-0.5">
                              <p className="textblack whitespace-nowrap">
                                <span className="font-medium textblack">From: </span>
                                <span className="font-semibold">{mail.senderName}</span>
                                <span className="textblack ml-1">({mail.senderEmail})</span>
                              </p>
                              <p className="textblack whitespace-nowrap">
                                <span className="font-medium textblack">To: </span>
                                <span className="font-semibold">{mail.recipientName}</span>
                                <span className="textblack ml-1">({mail.recipientEmail})</span>
                              </p>
                            </div>
                          </div>
                          <div className="flex-shrink-0 text-right">
                            <span className="text-xs sm:text-sm font-medium text-indigo-600 whitespace-nowrap">
                              {mail && mail.createdAt ? moment(mail.createdAt).format("DD MMM, YYYY") : ""}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </>
        )}

        {/* Footer */}
        <div className="flex justify-end gap-3 py-4 mt-2">
          {/* <button className=" text-indigo-600 border border-indigo-600 text-base  px-4 py-2 rounded-md" onClick={onClose}>Close</button> */}
          <div className="flex items-center justify-end gap-3">
            {step > 1 && (
              <button onClick={prevStep} className="flex items-center gap-2 px-4 py-2 text-base font-medium textblack border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
                <HiChevronLeft size={24} />
                <span>Back</span>
              </button>
            )}
            {step < 3 ? (
              <button onClick={nextStep} className="px-6 py-2 text-base font-semibold text-white bg-indigo-600 rounded-md hover:bg-indigo-700 active:scale-95 transition-all">Continue</button>
            ) : (
              <button onClick={() => handleFinalAssign(selected)} className="px-6 py-2 text-base font-semibold text-white bg-indigo-600 rounded-md hover:bg-indigo-700 active:scale-95 transition-all">Final Assign</button>
            )}
          </div>
        </div>
      </div>
    </div >
  );
}